import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

export const LoadingSpinner = ({ size }) => (
  <div style={{
      display: "flex",
      padding: 30,
      flexDirection: "column",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center"}}
  >
      <CircularProgress mode="indeterminate" size={size || 50} />
  </div>
);

LoadingSpinner.propTypes = {
  size: PropTypes.number
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/utils/LoadingSpinner/LoadingSpinner.js